import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { TResponseMeData } from '../types/api';

interface UserState {
  user: TResponseMeData | null;
  setUser: (user: TResponseMeData | null) => void;
}

const useUserStore = create(
  persist<UserState>(
    (set: any) => ({
      user: null,
      setUser: (user: any) => set({ user })
    }),
    {
      name: 'userInfo'
    }
  )
);

export default useUserStore;
